module.exports = __webpack_public_path__ + "images/emoji/wrench.0b2226bded378c5885d8.png";